let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("47wm8")).then(() => parcelRequire('48jO6'));